module.exports = __webpack_public_path__ + "img/stamp_h_received@2x.e9e30286.png";